import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import GiftCenterSelect from "./GiftCenterSelect";
import MemberSearch from "./MemberSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
    Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RetrunFindCoupon from './GiftFindMember';
import get_token from "../lib/get_token";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import PhoneFormatter from "../lib/PhoneFormatter";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
    { field: "id", headerName: "id", hide: true },
    {
        field: "center", headerName: "센터명", width: 130, align: "center",
        renderCell: (params) => {
            return <>{params.row.center} {params.row.location}</>
        }

    },
    { field: "mb_name", headerName: "이름", width: 130, align: "center" },
    {
        field: "mb_phone", headerName: "연락처", width: 130, align: "left",
        renderCell: (params) => {
            return <>{PhoneFormatter(params.row.mb_phone, 1)}</>
        }
    },
    { field: "regdate", headerName: "가입일", width: 130, align: "center" },
];

function GiftFindMember(props) {

    const { open, setOpen, login, pHandleChange } = props;
    const token = get_token();
    const title = '회원찾기';
    const [rows, setRows] = useState([]);
    const [data, setData] = useState({ // 1
        tcid: '',
        sname: '',
        sphone: '',
    });
    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass_admin/search_member", {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            tcid: data.tcid,
            sname: data.sname,
            sphone: data.sphone
        });
        if (result.data.success === 1) {
            setRows(result.data.rows);
        }
    };

    const onConfirm = (params) => {
        let { id, mb_name } = params.row;
        Swal.fire({
            html: `선택 하시겠습니까?`,
            title: "회원선택",
            showConfirmButton: true,
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                pHandleChange({
                    target: {
                        name: 'mname',
                        value: mb_name
                    }
                });
                pHandleChange({
                    target: {
                        name: 'tmcd',
                        value: id
                    }
                });
                setOpen(false);
            }
        });
    };

    useEffect(() => {
        if(open) {
            setRows([]);
        }       
    }, [open]);

    const handleChange = e => {
        setData(state => {
            let newState = state;
            newState[e.target.name] = e.target.value;
            return { ...newState };
        });
    }

    return <Dialog
        open={open}
        fullWidth={true}
        maxWidth="md"
        TransitionComponent={Transition}
        onClose={() => setOpen(false)}
    >
        <AppBar sx={{ position: "static" }}>
            <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography style={{ fontSize: 18 }}>{title}</Typography>
                </Box>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => setOpen(false)}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>

        <Box display="flex" p={1} mt={1}>
            <Box>
                <GiftCenterSelect
                    login={login}
                    pHandleChange={handleChange}
                />
            </Box>
            <Box ml={1}>
                <TextField
                    sx={{ width: 120 }}
                    name="sname"
                    label="이름"
                    size="small"
                    onChange={handleChange}
                    autoComplete="off"
                    value={data.sname}
                ></TextField>
            </Box>
            <Box sx={{ ml: 1 }}>
                <TextField
                    sx={{ width: 180 }}
                    name="sphone"
                    label="연락처"
                    size="small"
                    onChange={handleChange}
                    autoComplete="off"
                    value={data.sphone}
                ></TextField>
            </Box>
            <Box sx={{ ml: 1 }}>
                <Button variant="contained" size="medium" onClick={() => load_data()}>
                    찾기
                </Button>
            </Box>
        </Box>

        <Box sx={{ p: 1 }}>
            <DataGrid sx={{ minHeight: 500 }}
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[5]}
                checkboxSelection={false}
                onRowClick={(params) => {
                    onConfirm(params);
                }}
            />
        </Box>
    </Dialog>
}

export default GiftFindMember;